import React, { useEffect } from 'react';
import axios from 'axios';

export default function IRecBillingManagement() {

	const redirectToIRecUrl = async () => {
		const { data } = await axios.get(`${import.meta.env.VITE_ROOT_PATH}/api/url/irec`);
		if (!data?.url) return;
		const sanitized = encodeURI(data.url);
		const parsed = new URL(sanitized);
		if (parsed.protocol === 'https:' && parsed.hostname.endsWith('.adp.com')) {
			window.location.replace(parsed.href);
		}
	};

	useEffect(() => {
		redirectToIRecUrl();
	}, []);

	return <div></div>;
}
